<template>
  <div class="mt-2 flex overflow-hidden flex-grow">
    <div class="overflow-hidden flex flex-col pb-4 flex-grow bg-trader-gray mr-2">

      <!-- Go back -->
      <div class="w-full h-10">
        <CGoBack/>
      </div>

      <!-- Bearbeitung Weißer Hintergrund -->
      <div class="flex-grow overflow-hidden px-10 h-full flex text-center justify-center">

        <div class="overflow-auto bg-white rounded p-10 max-w-[1000px] flex-grow">

          <!-- Formular zum Erstellen -->
          <div v-if="!apiKeyCreated">
            <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
              <div class="w-full bg-primary p-2 rounded">
                <span class="text-xl">Neuen API-Key Erstellen</span>
              </div>
            </div>

            <div class="flex-grow flex flex-col space-y-4 overflow-auto">

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Name</span>
                <input
                    class="border p-2 rounded w-full"
                    required
                    v-model="name"
                    :class="{'border-red-500': showError && !this.name}"
                    data-ui="apikey-name"
                    placeholder="z.B. Production API Key">
              </div>

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Beschreibung</span>
                <textarea
                    class="border p-2 rounded w-full"
                    v-model="description"
                    :class="{'border-red-500': showError && !this.description}"
                    data-ui="apikey-description"
                    placeholder="Beschreibung des API-Keys..."
                    rows="4">
                </textarea>
              </div>

              <button
                  class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out"
                  @click="createApiKey"
                  data-ui="create-apikey-button">
                API-Key Erstellen
              </button>

            </div>
          </div>

          <!-- Anzeige nach Erstellung -->
          <div v-else>
            <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
              <div class="w-full bg-primary p-2 rounded">
                <span class="text-xl">API-Key erfolgreich erstellt</span>
              </div>
            </div>

            <div class="flex-grow flex flex-col space-y-4 overflow-auto">


              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Name</span>
                <input
                    class="border p-2 rounded w-full bg-gray-50"
                    :value="createdKeyData.name"
                    readonly>
              </div>

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Beschreibung</span>
                <textarea
                    class="border p-2 rounded w-full bg-gray-50"
                    :value="createdKeyData.description"
                    readonly
                    rows="4">
                </textarea>
              </div>

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">API-Key</span>
                <input
                    class="border p-2 rounded w-full bg-gray-50 font-mono text-sm"
                    :value="createdKeyData.key"
                    readonly>
              </div>

              <button
                  class="w-full rounded p-3 bg-trader-blue text-white hover:bg-blue-600 transition duration-200 ease-in-out"
                  @click="copyToClipboard"
                  data-ui="copy-apikey-button">
                {{ copied ? 'Kopiert!' : 'API-Key kopieren' }}
              </button>

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Erstellt am</span>
                <input
                    class="border p-2 rounded w-full bg-gray-50"
                    :value="formatDate(createdKeyData.createdAt)"
                    readonly>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>

    <Sidebar />
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "../../../apolloClient";
import router from "@/router";
import Sidebar from "@/components/Administration/Sidebar.vue";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";
import {query, mutation} from "@/graphql";

export default {
  components: {
    CGoBack,
    Sidebar,
    SuccessConfirmation
  },
  data() {
    return {
      name: "",
      description: "",
      showError: false,
      apiKeyCreated: false,
      createdKeyData: {
        name: "",
        description: "",
        key: "",
        createdAt: null
      },
      copied: false,
      accordionIndex: 0,
    };
  },
  methods: {
    goBack() {
      router.push(`/administration/${this.accordionIndex}`);
    },

    async createApiKey() {
      if (!this.name || !this.description) {
        this.showError = true;
        return;
      }
      this.showError = false;

      const apiKeyData = {
        id: 0,
        name: this.name,
        description: this.description
      };

      const [result, err] = await mutation.createApiKey(apiKeyData)
      if(err != null) {
        console.error(err);
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Fehler",
          message: "Der API-Key konnte nicht erstellt werden",
        });
      }

      console.log("result: %o", result);


      // Details mit getApiKey abfragen
      const [apiKeyDetails, error] = await query.getApiKey(result.id)
      console.log("apiKeyDetails: %o", apiKeyDetails);

      if (error == null) {
        this.createdKeyData = {
          name: apiKeyDetails.name || '',
          description: apiKeyDetails.description|| '' ,
          key: apiKeyDetails.key || '',
          createdAt: apiKeyDetails.createdAt || ''
        };
        this.apiKeyCreated = true;
      }



    },

    copyToClipboard() {
      navigator.clipboard.writeText(this.createdKeyData.key).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    resetForm() {
      this.name = "";
      this.description = "";
      this.showError = false;
      this.apiKeyCreated = false;
      this.createdKeyData = {
        name: "",
        description: "",
        key: "",
        createdAt: null
      };
      this.copied = false;
    }
  },
  watch: {
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.accordionIndex = this.$route.params.accordionIndex;
  }
};
</script>